module.exports = new __parcel__URL__("GT-Pantheon_animation-fig-11-Italic-angles-Clino-002.efd596e1.json").toString();